import { Kpi } from './kpi'

export enum UnitsOccupancyKpiKey {
  RENTED = 'RENTED',
  AVAILABLE = 'AVAILABLE',
}

export type UnitsOccupancyKpi = Kpi<UnitsOccupancyKpiKey>
